import {
  dcCrossConnectType,
  dcCrossConnectTypeFullName,
} from "../types/index.const";

const dcCrossConnectTypeOptions = dcCrossConnectType.map((el, index) => ({
  label: dcCrossConnectTypeFullName[index],
  value: el,
}));
export default dcCrossConnectTypeOptions;
